import React from 'react';
import FormItem from '../__partials/form-item';

interface IProps {
  header?: string;
  selectedValue?: any;
  children?: any;
  isDisabled?: boolean;
  status?: 'default' | 'error' | 'success';
  onClick?: any;
}

const RadioGroup = ({
  header,
  selectedValue,
  children,
  isDisabled,
  status,
  onClick,
}: IProps) => (
  <FormItem isDisabled={isDisabled} status={status}>
    {header && <p className="radio-group__header">{header}</p>}

    {children.map((child: any) => {
      return React.cloneElement(child, {
        key: child.props.value,
        onClick: () => onClick(child.props.value),
        isChecked: selectedValue === child.props.value,
      });
    })}
  </FormItem>
);

export default RadioGroup;
